import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCog,faPalette,faCrosshairs,faSearch, faFolder,faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AcuteFramework from 'acute-framework'

Vue.use(AcuteFramework)

library.add(faCog,faPalette,faCrosshairs,faSearch, faFolder,faBars)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
document.title="Acute Colors";
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
